/**
 * The job card's employment-type vocabulary (R-P5), shown as plain text leading
 * the subtitle line ("Full-time · NOAA", mockup jobs.html:628), never as a chip.
 * The feed is not normalised — stage carries `Full-time`, `Full time`,
 * `PERMANENT`, `Plein temps`, `Other` and null side by side. Known tokens fold
 * to one label each; `Other`, null and anything unknown are left out rather
 * than shown as a mystery word.
 */
const CANONICAL: Readonly<Record<string, string>> = {
    'full-time': 'Full-time',
    'full time': 'Full-time',
    'fulltime': 'Full-time',
    'plein temps': 'Full-time',
    'part-time': 'Part-time',
    'part time': 'Part-time',
    'contract': 'Contract',
    'temporary': 'Temporary',
    'internship': 'Internship',
    'volunteer': 'Volunteer',
    'permanent': 'Permanent',
};

export function CanonicalEmploymentType(raw: string | null): string | null {
    if (!raw) return null;
    return CANONICAL[raw.trim().toLowerCase()] ?? null;
}
